import script from "./NavIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NavIcon.vue?vue&type=script&setup=true&lang=js"

import "./NavIcon.vue?vue&type=style&index=0&id=8bb7f6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bb7f6f8"]])

export default __exports__